export default "__VITE_ASSET__D470XQlD__"